import { useAnnouncementBar } from '../../contexts/AnnouncementBarContext';

export default function AnnouncementBar() {
  const { isVisible, setIsVisible } = useAnnouncementBar();

  if (!isVisible) return null;

  return (
    <div className="bg-[#C9A84C] text-[#0d0d0d] py-2 sm:py-2.5 px-4 relative z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center justify-center gap-2 sm:gap-3 flex-1 text-center">
          <i className="ri-truck-line text-base sm:text-lg hidden xs:block"></i>
          <span
            className="text-[10px] sm:text-xs font-bold tracking-wide sm:tracking-wider uppercase"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            🚗 We Ship Nationwide — Delivering to 48 States
          </span>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center hover:bg-[#0d0d0d]/10 rounded-full transition-colors cursor-pointer flex-shrink-0"
          aria-label="Close announcement"
        >
          <i className="ri-close-line text-sm sm:text-base"></i>
        </button>
      </div>
    </div>
  );
}